import { GetApp } from "../../App"
import { Ship } from "../../App/Ship"
import { Block, BlockContainer, BlockField, BlockFieldInputs, BlockRow } from "../../Components/Block"
import { EditGroup } from "../../Components/EditGroup"
import { NumberInput } from "../../Components/Input"
import { UnitSelect } from "../../Components/UnitSelect"
import { GetShipData } from "./Context"
import { ShipDataDetailsViewProps } from "./Params"

export function ShipDataDetailsView(_: ShipDataDetailsViewProps) {
  const app = GetApp();
  const t = app.getT("ShipDataView");
  const { data, ship, editable, formEditable, edited, onEdited, save, selectedShipType, setSelectedShipType, shipType, vesselTypeOptions } = GetShipData();
  return (
    <EditGroup changed={edited} editable={formEditable} editableFields={[
      "shipType", "specialFeatures", { name: "height", type: "float" }, "heightUnit", { name: "draft", type: "float" }, "draftUnit", { name: "beam", type: "float" }, "beamUnit", { name: "lengthWaterline", type: "float" }, "lengthWaterlineUnit", { name: "lengthHull", type: "float" }, "lengthHullUnit", { name: "length", type: "float" }, "lengthUnit", { name: "displacement", type: "float" }, "displacementUnit", { name: "keelWeight", type: "float" }, "keelWeightUnit", { name: "keelWeightPercent", type: "float" }, "hullMaterial", "hullColor", "keelMaterial", "keelShape", { name: "masts", type: "int" }, "rig", { name: "sailAreaTotal", type: "float" }, "sailAreaTotalUnit",
      { name: "berthNo", type: "int" }, { name: "berthSingleNo", type: "int" }, { name: "berthDoubleNo", type: "int" }, { name: "berthExtraNo", type: "int" }, { name: "cabinsNo", type: "int" }, { name: "bathNo", type: "int" }, "saloon", "pantry", "cabins", "cockpit",

    ]} onSave={save}
    >

      {/* Vessel Type with sketch */}
      <BlockContainer>
        <Block className="ship-data-sketch">
          <BlockRow>
            <h3>{t("vessel_type")}</h3>
          </BlockRow>
          {selectedShipType && (
            <>
              <BlockRow className="ship_data_sketch_features">
                <BlockField className="ship-sketch-column">
                  <select className="ShipTypeSelect" disabled={!editable} name="shipType" value={shipType} onChange={(e) => { setSelectedShipType(e.target.value); onEdited(); }}>
                    {ship.vesselType && vesselTypeOptions[ship.vesselType].map((type) => (
                      <option value={type} key={type}>{t(`${type}`)}</option>
                    ))}
                  </select>
                  <img className="ShipSketch" src={"/ship-" + shipType + ".svg"} />
                </BlockField>
                <BlockField label={t("special_features")}>
                  <textarea defaultValue={data.specialFeatures} name="specialFeatures" onChange={onEdited} rows={4} readOnly={!formEditable}></textarea>
                </BlockField>
              </BlockRow>
            </>
          )}
        </Block>

        <Block>
          <BlockRow>
            <h3>{t("dimensions")}</h3>
          </BlockRow>

          <BlockRow className="ship-data-dimensions">
            <BlockField label={t("height")} className="block_field_small_12">
              <BlockFieldInputs>
                <NumberInput format="float" className="unit" defaultValue={data.height} name="height" onChange={onEdited} readOnly={!editable} />
                <UnitSelect kind="length" name="heightUnit" value={data.heightUnit} editable={editable} onChange={onEdited} />
              </BlockFieldInputs>
            </BlockField>
            <BlockField label={t("draft")} className="block_field_small_12">
              <BlockFieldInputs>
                <NumberInput format="float" className="unit" defaultValue={data.draft} name="draft" onChange={onEdited} readOnly={!editable} />
                <UnitSelect kind="length" name="draftUnit" value={data.draftUnit} editable={editable} onChange={onEdited} />
              </BlockFieldInputs>
            </BlockField>
            <BlockField label={t("beam")} className="block_field_small_12">
              <BlockFieldInputs>
                <NumberInput format="float" className="unit" defaultValue={data.beam} name="beam" onChange={onEdited} readOnly={!editable} />
                <UnitSelect kind="length" name="beamUnit" value={data.beamUnit} editable={editable} onChange={onEdited} />
              </BlockFieldInputs>
            </BlockField>
          </BlockRow>

          <BlockRow>
            <BlockField label={t("length_waterline")} className="block_field_small_12">
              <BlockFieldInputs>
                <NumberInput format="float" className="unit" defaultValue={data.lengthWaterline} name="lengthWaterline" onChange={onEdited} readOnly={!editable} />
                <UnitSelect kind="length" name="lengthWaterlineUnit" value={data.lengthWaterlineUnit} editable={editable} onChange={onEdited} />
              </BlockFieldInputs>
            </BlockField>
            <BlockField label={t("length_hull")} className="block_field_small_12">
              <BlockFieldInputs>
                <NumberInput format="float" className="unit" defaultValue={data.lengthHull} name="lengthHull" onChange={onEdited} readOnly={!editable} />
                <UnitSelect kind="length" name="lengthHullUnit" value={data.lengthHullUnit} editable={editable} onChange={onEdited} />
              </BlockFieldInputs>
            </BlockField>
            <BlockField label={t("length")} className="block_field_small_12">
              <BlockFieldInputs>
                <NumberInput format="float" className="unit" defaultValue={data.length} name="length" onChange={onEdited} readOnly={!editable} />
                <UnitSelect kind="length" name="lengthUnit" value={data.lengthUnit} editable={editable} onChange={onEdited} />
              </BlockFieldInputs>
            </BlockField>
          </BlockRow>

          <BlockRow>
            <BlockField label={t("displacement")} className="block_field_small_12">
              <BlockFieldInputs>
                <NumberInput format="float" className="unit" defaultValue={data.displacement} name="displacement" onChange={onEdited} readOnly={!editable} />
                <UnitSelect kind="weight" name="displacementUnit" value={data.displacementUnit} editable={editable} onChange={onEdited} />
              </BlockFieldInputs>
            </BlockField>
            <BlockField label={t("keel_weight")} className="block_field_small_12">
              <BlockFieldInputs>
                <NumberInput format="float" className="unit" defaultValue={data.keelWeight} name="keelWeight" onChange={onEdited} readOnly={!editable} />
                <UnitSelect kind="weight" name="keelWeightUnit" value={data.keelWeightUnit} editable={editable} onChange={onEdited} />
              </BlockFieldInputs>
            </BlockField>
            <BlockField label={t("keel_weight_percent")} className="block_field_small_12">
              <input defaultValue={data.keelWeightPercent} name="keelWeightPercent" onChange={onEdited} readOnly={!editable} />
            </BlockField>
          </BlockRow>

          <BlockRow>
            <BlockField label={t("hull_material")} className="block_field_small_12">
              <input defaultValue={data.hullMaterial} name="hullMaterial" onChange={onEdited} readOnly={!editable} />
            </BlockField>
            <BlockField label={t("hull_color")} className="block_field_small_12">
              <input defaultValue={data.hullColor} name="hullColor" onChange={onEdited} readOnly={!editable} />
            </BlockField>
          </BlockRow>

          <BlockRow>
            <BlockField label={t("keel_material")} className="block_field_small_12">
              <input defaultValue={data.keelMaterial} name="keelMaterial" onChange={onEdited} readOnly={!editable} />
            </BlockField>
            <BlockField label={t("keel_shape")} className="block_field_small_12">
              <input defaultValue={data.keelShape} name="keelShape" onChange={onEdited} readOnly={!editable} />
            </BlockField>
          </BlockRow>

          {Ship.isSailingVessel(ship) && (
            <BlockRow>
              <BlockField label={t("masts_no")} className="block_field_small_8">
                <NumberInput format="int" defaultValue={data.masts} name="masts" onChange={onEdited} readOnly={!editable} />
              </BlockField>
              <BlockField label={t("rig")}>
                <input defaultValue={data.rig} name="rig" onChange={onEdited} readOnly={!editable} />
              </BlockField>
              <BlockField label={t("sail_area_total")} className="block_field_small_10">
                <BlockFieldInputs>
                  <NumberInput format="float" className="unit" defaultValue={data.sailAreaTotal} name="sailAreaTotal" onChange={onEdited} readOnly={!editable} />
                  <UnitSelect kind="surface" name="sailAreaTotalUnit" value={data.sailAreaTotalUnit} editable={editable} onChange={onEdited} />
                </BlockFieldInputs>
              </BlockField>
            </BlockRow>
          )}

        </Block>
      </BlockContainer>

      {/* Inside */}
      <BlockContainer>
        <Block>
          <BlockRow>
            <h3>{t("inside")}</h3>
          </BlockRow>

          <BlockRow className="inside-numbers-row">
            <BlockField label={t("berth_no")} className="block_field_small_10">
              <NumberInput format="int" defaultValue={data.berthNo} name="berthNo" onChange={onEdited} readOnly={!editable} />
            </BlockField>
            <BlockField label={t("berth_single_no")} className="block_field_small_10">
              <NumberInput format="int" defaultValue={data.berthSingleNo} name="berthSingleNo" onChange={onEdited} readOnly={!editable} />
            </BlockField>
            <BlockField label={t("berth_double_no")} className="block_field_small_10">
              <NumberInput format="int" defaultValue={data.berthDoubleNo} name="berthDoubleNo" onChange={onEdited} readOnly={!editable} />
            </BlockField>
            <BlockField label={t("berth_extra_no")} className="block_field_small_10">
              <NumberInput format="int" defaultValue={data.berthExtraNo} name="berthExtraNo" onChange={onEdited} readOnly={!editable} />
            </BlockField>
            <BlockField label={t("cabins_no")} className="block_field_small_10">
              <NumberInput format="int" defaultValue={data.cabinsNo} name="cabinsNo" onChange={onEdited} readOnly={!editable} />
            </BlockField>
            <BlockField label={t("bath_no")} className="block_field_small_10">
              <NumberInput format="int" defaultValue={data.bathNo} name="bathNo" onChange={onEdited} readOnly={!editable} />
            </BlockField>
          </BlockRow>

          <BlockRow className="living_areas">
            <BlockField label={t("saloon")}>
              <textarea defaultValue={data.saloon} rows={4} name="saloon" onChange={onEdited} readOnly={!formEditable}></textarea>
            </BlockField>
            <BlockField label={t("pantry")}>
              <textarea defaultValue={data.pantry} rows={4} name="pantry" onChange={onEdited} readOnly={!formEditable}></textarea>
            </BlockField>
            <BlockField label={t("cabins")}>
              <textarea defaultValue={data.cabins} rows={4} name="cabins" onChange={onEdited} readOnly={!formEditable}></textarea>
            </BlockField>
            <BlockField label={t("cockpit")}>
              <textarea defaultValue={data.cockpit} rows={4} name="cockpit" onChange={onEdited} readOnly={!formEditable}></textarea>
            </BlockField>

          </BlockRow>
        </Block>
      </BlockContainer>
    </EditGroup>
  );
}
